import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusesSection } from '../components/BonusesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsBottom } from '../components/TestimonialsBottom';
import { FaqSection } from '../components/FaqSection';
import { FinalPricingCTA } from '../components/FinalPricingCTA';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
export function Landing() {
  return <main className="min-h-screen bg-transparent" data-id="element-177">
      <HeroSection data-id="element-178" />
      <ProblemSection data-id="element-179" />
      <div className="cv-section" data-id="element-180">
        <SolutionSection data-id="element-181" />
      </div>
      <div className="cv-section" data-id="element-182">
        <FeaturesSection data-id="element-183" />
      </div>
      <div className="cv-section" data-id="element-184">
        <ModulesSection data-id="element-185" />
      </div>
      <div className="cv-section" data-id="element-186">
        <BonusesSection data-id="element-187" />
      </div>
      <div className="cv-section" data-id="element-188">
        <BenefitsSection data-id="element-189" />
      </div>
      <PricingSection data-id="element-190" />
      <div className="cv-section" data-id="element-191">
        <GuaranteeSection data-id="element-192" />
      </div>
      <div className="cv-section" data-id="element-193">
        <TestimonialsBottom data-id="element-194" />
      </div>
      <div className="cv-section" data-id="element-195">
        <FaqSection data-id="element-196" />
      </div>
      <div className="cv-section" data-id="element-197">
        <FinalPricingCTA data-id="element-198" />
      </div>
      <Footer data-id="element-199" />
      <StickyCTA data-id="element-200" />
    </main>;
}